var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowEntityRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 80,
    viewBox: "0 0 131 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 40C51 17.9086 68.9086 0 91 0C113.091 0 131 17.9086 131 40C131 62.0914 113.091 80 91 80C68.9086 80 51 62.0914 51 40Z",
    fill: "#ECF8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9997 31.6667V28.3333C90.9997 26.5 89.4997 25 87.6663 25H77.6663C75.833 25 74.333 26.5 74.333 28.3333V51.6667C74.333 53.5 75.833 55 77.6663 55H104.333C106.166 55 107.666 53.5 107.666 51.6667V35C107.666 33.1667 106.166 31.6667 104.333 31.6667H90.9997ZM87.6663 51.6667H77.6663V48.3333H87.6663V51.6667ZM87.6663 45H77.6663V41.6667H87.6663V45ZM87.6663 38.3333H77.6663V35H87.6663V38.3333ZM87.6663 31.6667H77.6663V28.3333H87.6663V31.6667ZM104.333 51.6667H90.9997V35H104.333V51.6667ZM101 38.3333H94.333V41.6667H101V38.3333ZM101 45H94.333V48.3333H101V45Z",
    fill: "#00707A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 28.9543 8.95431 20 20 20C31.0457 20 40 28.9543 40 40C40 51.0457 31.0457 60 20 60C8.95431 60 0 51.0457 0 40Z",
    fill: "#ECF8F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0002C22.4558 40.0002 24.4447 38.0113 24.4447 35.5558C24.4447 33.1002 22.4558 31.1113 20.0002 31.1113C17.5447 31.1113 15.5558 33.1002 15.5558 35.5558C15.5558 38.0113 17.5447 40.0002 20.0002 40.0002ZM20.0002 42.2224C17.0335 42.2224 11.1113 43.7113 11.1113 46.6669V47.778C11.1113 48.3891 11.6113 48.8891 12.2224 48.8891H27.778C28.3891 48.8891 28.8891 48.3891 28.8891 47.778V46.6669C28.8891 43.7113 22.9669 42.2224 20.0002 42.2224Z",
    fill: "#00707A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7071 40.7071C60.0976 40.3166 60.0976 39.6834 59.7071 39.2929L53.3431 32.9289C52.9526 32.5384 52.3195 32.5384 51.9289 32.9289C51.5384 33.3195 51.5384 33.9526 51.9289 34.3431L57.5858 40L51.9289 45.6569C51.5384 46.0474 51.5384 46.6805 51.9289 47.0711C52.3195 47.4616 52.9526 47.4616 53.3431 47.0711L59.7071 40.7071ZM42 41H59V39H42V41Z",
    fill: "#21496B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEntityRedirect);
export default __webpack_public_path__ + "static/media/arrow-entity-redirect.82efd4efab41ee2674fba94df6612f6f.svg";
export { ForwardRef as ReactComponent };